import React, {useEffect, useState} from 'react';
import '../ChestPurchaseModal/ChestPurchaseModal.css';
import './RatingCrystalsRewardModal.css';
import PageButton from '../../elements/PageButton/PageButton';
import {RatingCrystalsRewardRow} from '../../pages/RatingCrystalsPage/RatingCrystalsRewardRow';
import {getRatingCrystalsImagePath} from '../../../configs/ratingCrystals';
import {getLeagueByRating} from '../../../utils/rating/getLeagueByRating';
import {MINUS_SIGN} from '../../../constants/text';
import {MENU_SOUND_MANAGER} from '../../../scenes/MenuSoundManager';

const PAGE_ID = 'RatingCrystalsRewardModal';

/**
 * Модалка «Кристаллы за рейтинг» в главном меню: показывает всё, что игроку
 * начислили с прошлого просмотра.
 *
 * Построена на тех же классах, что модалка премиум-награды
 * (chest-purchase-*), но подсвечена цветом кристаллов — как модалка
 * «Недостаточно кристаллов». Ниже списка — суммарное изменение рейтинга в том
 * же виде, что в итогах матча.
 *
 * Кристаллы к моменту показа уже начислены сервером; кнопка «Отлично» лишь
 * помечает записи прочитанными.
 */
const RatingCrystalsRewardModal = ({rewards, currentRating, onClose}) => {
  const [visible, setVisible] = useState(false);

  // Звук и появление — только если есть что показывать: ниже пустой список
  // дает return null, и звучать при этом модалка не должна
  const hasRewards = Boolean(rewards && rewards.length > 0);
  useEffect(() => {
    if (!hasRewards) return undefined;
    MENU_SOUND_MANAGER.playMineExploration();
    const showTimer = setTimeout(() => setVisible(true), 50);
    return () => clearTimeout(showTimer);
  }, [hasRewards]);

  if (!rewards || rewards.length === 0) {
    return null;
  }

  const totalCrystals = rewards.reduce((sum, reward) => sum + (reward.crystals || 0), 0);
  const totalRatingDelta = rewards.reduce((sum, reward) => sum + (reward.ratingDelta || 0), 0);
  const league = getLeagueByRating(currentRating);

  const handleClose = () => {
    setVisible(false);
    setTimeout(() => onClose?.(rewards.map((reward) => reward.id)), 300);
  };

  return (
    <div
      className={`chest-purchase-overlay rating-crystals-overlay ${visible ? 'chest-purchase-overlay_visible' : ''}`}
      role={'dialog'}
      aria-modal={'true'}
    >
      <div
        className={`chest-purchase-modal rating-crystals-modal ${visible ? 'chest-purchase-modal_visible' : ''}`}
      >
        <div className={'chest-purchase-content'}>
          <h2 className={'rating-crystals-modal_title text-crystals'}>Кристаллы за рейтинг</h2>

          <div className={'chest-purchase-image-wrapper'}>
            <img
              className={'chest-purchase-image'}
              src={getRatingCrystalsImagePath(totalCrystals)}
              alt={'Кристаллы'}
            />
          </div>

          <h3 className={'chest-purchase-name text-crystals rating-crystals-modal_total'}>
            +{totalCrystals}
            <img
              className={'rating-crystals-modal_total-icon'}
              src={'/img/icons/crystal.png'}
              alt={'Кристаллы'}
            />
          </h3>

          {totalRatingDelta !== 0 && (
            <div className={'rating-crystals-modal_rating'}>
              <span className={'rating-crystals-modal_rating-label'}>Рейтинг:</span>
              <span className={'text-rating'}>{MINUS_SIGN}{Math.abs(totalRatingDelta)}</span>
              <span className={'rating-crystals-modal_rating-arrow'}>→</span>
              <span className={'text-rating rating-crystals-modal_rating-value'}>{currentRating}</span>
              <img
                className={'rating-crystals-modal_rating-league-icon'}
                src={league.iconPath}
                alt={league.name}
                title={league.name}
              />
            </div>
          )}

          <div className={'rating-crystals-modal_list'}>
            {rewards.map((reward) => (
              <RatingCrystalsRewardRow key={reward.id} reward={reward} isCompact/>
            ))}
          </div>

          <div className={'main-menu-buttons chest-purchase-buttons'}>
            <PageButton onClick={handleClose} pageId={PAGE_ID} buttonId={'confirm'}>
              Отлично!
            </PageButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RatingCrystalsRewardModal;
